<template>
    <div id="webtop">
        <div v-show="serverResponseMsg">
            <div class="errorMsg center">
                <span>{{ serverResponseMsg }}</span>
            </div>
            <br>
        </div>
        <div class="container-fluid" id="containerForm" v-show="!loading">
            <div class="row item" >
                <div class="col-12 padding12-top-bottom">
                    <strong>お知らせ</strong><br>
                </div>
            </div>
            <div class="top_info">
                <div class="row font-size-small text-left"  >
                    <div class="col-12 comment">
                        <span v-html="notification"></span>
                    </div>
                </div>
            </div>
            <div class="row item" >
                <div class="col-12 padding12-top-bottom">
                    <strong>ご注意事項</strong><br>
                </div>
            </div>
            <div class="top_info">
                <div class="row font-size-small text-left"  >
                    <div class="col-12">
                        <CautionInfo/>
                    </div>
                </div>
            </div>
            <div class="row text-center" >
                <div class="col-12  padding12-top-bottom">
                    <button class="btn buttonForm btn-sm rounded-pill btn-u2m" id="sendbutton" v-if="buttonVisible" v-on:click="daccount_login">問い合わせをする</button>
                    <form name="sendrequest" method="post">
                        <input type="hidden" name="scope" v-model="requestData.scope">
                        <input type="hidden" name="response_type" v-model="requestData.response_type">
                        <input type="hidden" name="client_id" v-model="requestData.client_id">
                        <input type="hidden" name="redirect_uri" v-model="requestData.redirect_uri">
                        <input type="hidden" id="send_state" name="state" v-model="requestData.state">
                        <input type="hidden" id="send_nonce" name="nonce" v-model="requestData.nonce">
                        <input type="hidden" name="prompt" v-model="requestData.prompt">
                        <input type="hidden" name="ui_locales" v-model="requestData.ui_locales">
                        <input type="hidden" name="authif" v-model="requestData.authif">
                    </form>
                </div>
            </div>
            <div class="row text-center" >
                <div class="col-12  padding12-top-bottom">
                    <button class="btn buttonForm btn-sm rounded-pill btn-u2m" id="historybotton" v-if="buttonVisible" v-on:click="daccount_login_history">問い合わせ状況を確認する</button>
                    <form name="historyrequest" method="post">
                        <input type="hidden" name="scope" v-model="requestData.scope">
                        <input type="hidden" name="response_type" v-model="requestData.response_type">
                        <input type="hidden" name="client_id" v-model="requestData.client_id">
                        <input type="hidden" name="redirect_uri" v-model="requestData.redirect_uri_history">
                        <input type="hidden" id="history_state" name="state" v-model="requestData.state">
                        <input type="hidden" id="history_nonce" name="nonce" v-model="requestData.nonce">
                        <input type="hidden" name="prompt" v-model="requestData.prompt">
                        <input type="hidden" name="ui_locales" v-model="requestData.ui_locales">
                        <input type="hidden" name="authif" v-model="requestData.authif">
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { defineComponent } from 'vue'
import CautionInfo from '@/components/CautionInfo.vue'
export default defineComponent({
    name: 'web-top',
    components: {
        CautionInfo
    },
    data() {
        return({
            notification: "",
            buttonVisible: true,
            loading: false,
            serverResponseMsg: "",
            sendurl: process.env.VUE_APP_DAUTH_URL,
            requestData: {}
        })
    },
    created: function() {
    },
    mounted: function(){
        // 初期画面表示時はTop画面のまま、dアカウント認証を行う
        if(this.$route.path == '/') {
            this.$store.dispatch("updateServiceSelectFlg", false)
            this.$store.dispatch("resetVariable")
            this.apiGW_GET()
            this.set_requestdata()
        }else{
            // ブラウザバックで戻ってきた場合や、
            // dアカウント認証画面からリダイレクトされてきた場合は自動で画面遷移
            let queryParams = {
                "code": this.$route.query.code,
                "state": this.$route.query.state
            }
            if(typeof this.$route.query.error != 'undefined'){
                queryParams["error"] = this.$route.query.error
            }
            if (this.$route.path == "/home"){
                this.$router.push({path:`/enquiryhome`, query: queryParams})
            }else if (this.$route.path == "/enquirylist"){
                this.$router.push({path:`/enquiryinfolist`, query: queryParams})
            }
        }
    },
    methods: {
        set_requestdata: function() {
            // リクエストデータ作成
            this.requestData.scope = "openid DocomoID accountid_n"
            this.requestData.response_type = "code"
            this.requestData.client_id = process.env.VUE_APP_DCLIENTID
            this.requestData.redirect_uri = process.env.VUE_APP_REDIRECT_URL
            this.requestData.redirect_uri_history = process.env.VUE_APP_REDIRECT_HISTORY_URL
            this.requestData.prompt = "relogin"
            this.requestData.ui_locales = "ja"
            this.requestData.authif = "1"
            this.requestData.state = ""
            this.requestData.nonce = ""
        },
        create_uuid: function(){
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(a) {
                let r = (new Date().getTime() + Math.random() * 16)%16 | 0, v = a == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        daccount_login: function() {
            this.reset_authdata()
            document.sendrequest.action=this.sendurl
            document.getElementById("send_state").value = this.requestData.state
            document.getElementById("send_nonce").value = this.requestData.nonce
            if (this.apiGW_login(document.sendrequest) == false) {
                return
            }
        },
        daccount_login_history: function() {
            this.reset_authdata()
            document.historyrequest.action=this.sendurl
            document.getElementById("history_state").value = this.requestData.state
            document.getElementById("history_nonce").value = this.requestData.nonce
            if (this.apiGW_login(document.historyrequest) == false) {
                return
            }
        },
        reset_authdata: function() {
            this.requestData.state = this.create_uuid()
            this.requestData.nonce = this.create_uuid()
            this.$store.dispatch("resetVariable")
            this.$store.dispatch("updateUserinfoFlg", false)
        },
        apiGW_login: function(targetform) {
            // エラーメッセージリセット
            this.clean_msg()
            this.loading = true
            this.buttonVisible = false

            var requestData = {
                "state": this.requestData.state
            }
            var result = true
            // API呼び出し（同期）
            this.$api.post('/login', requestData)
            .then(() => {
                targetform.submit()
            })
            .catch(error => {

                // ログインエラー時、次画面以降の処理ができない。
                var serverResponseStatusCode = error.response.status
                var serverResponseError = error.response.data

                if(serverResponseStatusCode === 500){
                    this.serverResponseMsg = serverResponseError["error_msg"]
                }
                else{
                    this.serverResponseMsg = "予期せぬエラーが発生しました。";
                }
                result = false
            })
            .finally(() => {
                this.buttonVisible = true
                this.loading = false
            })
            return result
        },
        // 一覧取得API呼出し
        apiGW_GET: async function() {
            // エラーメッセージリセット
            this.clean_msg()

            this.loading = true
            this.buttonVisible = false

            // 画面に表示する一覧をリセット
            this.notification = ""

            // API呼び出し（同期）
            this.$api.get('/get_notification')
            .then(response => {

                this.notification = response.data.notification_body
            })
            .catch(error => {

                // お知らせが表示できないだけなので処理としては継続しておく
                var serverResponseStatusCode = error.response.status
                var serverResponseError = error.response.data

                if(serverResponseStatusCode === 500){
                    this.serverResponseMsg = serverResponseError["error_msg"]
                }
                else{
                    this.serverResponseMsg = "予期せぬエラーが発生しました。";
                }
            })
            .finally(() => {
                this.buttonVisible = true
                this.loading = false
            })
        },
        // エラーメッセージクリア
        clean_msg: function(){
            // 画面メッセージの初期化
            this.serverResponseMsg = ""
        },
    }
})
</script>

<style>
.padding {
    padding: 10px;
}
.padding-top {
    padding-top: 10px
}
.box-1 {
    border: 3px solid rgb(240, 239, 239);
    border-radius: 10px;
}

.item {
    background: rgb(240, 239, 239);
}
.font-size-small {
        font-size: 14px;
}
.top_info{
    max-width: 350px;
    margin: 0 auto;
}
</style>
